
import 'lazysizes';

export function LoadImages(container = document) {
    lazySizes.init();
}

